import {HttpAxiosRequest} from "../../httpAxiosBase";
import {ClientAfipActivity} from "../../../types/client/clientData";

export const HttpClientAfipActivity = {
    getEndpoint: (intIdClient: number, url = ""): string => `cliente/${intIdClient}/afip-actividad${url}`,

    getByIdClient: (intIdClient: number): Promise<ClientAfipActivity[]> => {
        return HttpAxiosRequest.get(
            HttpClientAfipActivity.getEndpoint(intIdClient)
        );
    },
}